const statusCircleColor = ["#12B76A", "#FEC84B", "#F97066", "#667085"];

const ChannelCircle: React.FC<any> = ({ channel, status, position }) => (
  <span
    style={{
      backgroundColor: statusCircleColor[status] || "blue",
      ...position,
    }}
    className="channel-circle"
  >
    {channel}
  </span>
);

export default ChannelCircle;
